import * as React from 'react'
import { PortWidget } from 'mrblenny-storm-react-diagrams'
import s from './CustomNodeWidget.scss'
import { nodes } from '../../Flow.data'
import { values, flow, filter, map, find, isEmpty } from 'lodash/fp'
import IconExpandMore from 'components/Icons/ExpandMore'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'

const showPorts = (node, type, nodeInfo) =>
  flow(
    values,
    filter(port => port.type === type),
    map(port => {
      const portInfo = find(['name', port.name])(nodeInfo.outputs) || {}
      return (
        <PortWidget
          extraProps={{
            title: portInfo.label,
            /*eslint-disable */
            children:
              type === 'output' && !port.name.startsWith('output-') ? (
                portInfo.icon ? (
                  <portInfo.icon />
                ) : (
                  portInfo.name
                )
              ) : (
                <IconExpandMore />
              ),
            /*eslint-enable */
          }}
          key={port.name}
          name={port.name}
          node={node}
          className={s.port}
        />
      )
    })
  )(node.ports)

export default class CustomNodeWidget extends React.Component {
  render() {
    const { node, pricing, form, flow } = this.props

    const noErrors = isEmpty(form.syncErrors || {})
    const nodeInfo = nodes[node.type]
    const formData = form.values
    const nodeWithFormData = {
      ...node,
      extras: formData || node.extras,
    }
    const priceId = nodeInfo.getPriceId ? nodeInfo.getPriceId(nodeWithFormData) : ''
    const price = pricing[priceId]

    return (
      <div>
        <div className={s.inputs} title="Inputs">
          {showPorts(node, 'input', nodeInfo)}
        </div>
        <div className={s.widget}>
          <div className={s.title}>
            <nodeInfo.icon />
            <div className={cn(sLay.flex, s.label)}>{nodeInfo.label}</div>
            {price && (
              <div
                className={cn(s.price, sLay['layout-column'], sLay['layout-align-center-center'])}
                title={price.description}
              >
                {price.value * 100}c/{price.divisor}
              </div>
            )}
          </div>
          <div className={s.body}>
            {noErrors ? (
              <nodeInfo.display node={nodeWithFormData} flow={flow} />
            ) : (
              <span className={sText.warn}>Invalid configuration</span>
            )}
          </div>
        </div>
        <div className={s.outputs} title="Outputs">
          {showPorts(node, 'output', nodeInfo)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomNodeWidget/CustomNodeWidget.jsx